'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
import { Iconify } from '@/components/atoms/Iconify';
import { useUserStore } from '@/entities/User/store/userStoreProvider';
import { cn } from '@/libs/utils';
import { addFavoritesOptions } from '../api/addFavorites';
import { removeFavoritesOptions } from '../api/removeFavorites';
import type { Experience } from '../type/experiences';
export const ExperienceFavoriteButton = t0 => {
  const $ = _c(35);
  const {
    is_in_favorites,
    id,
    className
  } = t0;
  const [isFavorite, setIsFavorite] = useState(is_in_favorites);
  const queryClient = useQueryClient();
  const user = useUserStore(_temp);
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["add-favorites"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== queryClient) {
    t2 = {
      mutationKey: t1,
      mutationFn: addFavoritesOptions,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["experiences-list"]
        });
        queryClient.invalidateQueries({
          queryKey: ["my-experiences"]
        });
        queryClient.invalidateQueries({
          queryKey: ["my-favotites"]
        });
      }
    };
    $[1] = queryClient;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    mutate: addFavorites
  } = useMutation(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["add-favorites"];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== queryClient) {
    t4 = {
      mutationKey: t3,
      mutationFn: removeFavoritesOptions,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["experiences-list"]
        });
        queryClient.invalidateQueries({
          queryKey: ["my-experiences"]
        });
        queryClient.invalidateQueries({
          queryKey: ["my-favotites"]
        });
      }
    };
    $[4] = queryClient;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    mutate: removeFavorites
  } = useMutation(t4);
  let t5;
  if ($[6] !== isFavorite || $[7] !== router || $[8] !== user?.id) {
    t5 = () => {
      if (user?.id) {
        setIsFavorite(!isFavorite);
      } else {
        router.push("/auth");
      }
    };
    $[6] = isFavorite;
    $[7] = router;
    $[8] = user?.id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const likeChange = t5;
  const [debouncedIsFavorite] = useDebounceValue(isFavorite, 300);
  let t6;
  if ($[10] !== addFavorites || $[11] !== debouncedIsFavorite || $[12] !== id || $[13] !== isFavorite || $[14] !== is_in_favorites || $[15] !== removeFavorites || $[16] !== user?.id) {
    t6 = () => {
      if (user?.id && isFavorite !== is_in_favorites) {
        ;
        try {
          if (debouncedIsFavorite) {
            addFavorites(id);
          } else {
            removeFavorites(id);
          }
        } catch (t7) {
          const e = t7;
          console.error(e);
        }
      }
    };
    $[10] = addFavorites;
    $[11] = debouncedIsFavorite;
    $[12] = id;
    $[13] = isFavorite;
    $[14] = is_in_favorites;
    $[15] = removeFavorites;
    $[16] = user?.id;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const t7 = user?.id;
  let t8;
  if ($[18] !== addFavorites || $[19] !== debouncedIsFavorite || $[20] !== id || $[21] !== isFavorite || $[22] !== is_in_favorites || $[23] !== removeFavorites || $[24] !== t7) {
    t8 = [debouncedIsFavorite, is_in_favorites, id, removeFavorites, t7, isFavorite, addFavorites];
    $[18] = addFavorites;
    $[19] = debouncedIsFavorite;
    $[20] = id;
    $[21] = isFavorite;
    $[22] = is_in_favorites;
    $[23] = removeFavorites;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  useEffect(t6, t8);
  let t9;
  if ($[26] !== likeChange) {
    t9 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      likeChange();
    };
    $[26] = likeChange;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const onClick = t9;
  const t10 = isFavorite ? "text-[#2A72FD] bg-[#FFFFFF]" : "text-[#D9D9D9] bg-[#352E7359] backdrop-blur-[4px]";
  let t11;
  if ($[28] !== className || $[29] !== t10) {
    t11 = cn("\n          rounded-full size-8 \n          inline-flex items-center justify-center\n          transition-all duration-300\n          hover:brightness-75\n          active:brightness-90\n        ", t10, className);
    $[28] = className;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Iconify icon="mdi:heart" className="size-4 transition-all duration-300" />;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== onClick || $[33] !== t11) {
    t13 = <button type="button" className={t11} onClick={onClick}>{t12}</button>;
    $[32] = onClick;
    $[33] = t11;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
function _temp(store) {
  return store.user;
}